import React from "react";
import { Pie } from "react-chartjs-2";
import { Chart, ArcElement, Tooltip, Legend } from 'chart.js';
import { makeRandomColorRGB } from '../../util/rotinas';
Chart.register(
  ArcElement,
  Tooltip,
  Legend
);

export function PieChartPixPorInstituicao({ title, dados }) {

  const colors = dados.map(i => makeRandomColorRGB())

  const label = (context) => {
    let label = 'QTD Movimentações';
    if (label) {
      label += ': ';
    }
    if (context.parsed !== null) {
      label += context.parsed;
    }
    return label;
  }

  const data = {
    labels: dados.map(i => i.instituition),
    datasets: [
      {
        label: 'Retorno Mensal',
        data: dados.map(i => i.total),
        backgroundColor: colors,
        borderColor: colors,
        borderWidth: 1,
      },
    ],
  };

  const options = {
    plugins: {
      title: {
        display: true,
        text: title.toUpperCase(),
        font: {
          size: 16
        }
      },
      subtitle: {
        display: true,
        text: '* Clique nos labels a esquerda para manipular a exibição',
        position: 'bottom',
        padding: '10',
      },

      legend: {
        position: 'bottom',
        padding: 20
      },
    },
    responsive: true,
    interaction: {
      mode: 'point',
      intersect: true
    }
  };

  return (
    <div >
      <Pie options={options} data={data} height={150} />
    </div>
  )
}
